/** Paleta de cores por tipo de cronograma — compartilhada entre CronogramaAtivoSection e CronogramaCalendarView. */
export interface TipoColorStyle {
  color:  string;
  bg:     string;
  border: string;
}

export const TIPO_COLORS: Record<string, TipoColorStyle> = {
  JUROS:           { color: '#2C91AD', bg: '#EBF7FA', border: '#9DD8E8' },
  PRINCIPAL:       { color: '#29A152', bg: '#F0FBF4', border: '#86EFAC' },
  PRINCIPAL_JUROS: { color: '#7B5EA7', bg: '#F3EFF9', border: '#C4AEE8' },
  RESGATE_TOTAL:   { color: '#E51739', bg: '#FEF2F4', border: '#FCA5A5' },
  PERSONALIZADO:   { color: '#6B7A8D', bg: '#F4F7F9', border: '#CFD8E5' },
};

const FALLBACK: TipoColorStyle = { color: '#6B7A8D', bg: '#F4F7F9', border: '#CFD8E5' };

export const getTipoColor = (tipo: string): TipoColorStyle =>
  TIPO_COLORS[tipo] ?? FALLBACK;